import DuplicateSalesTransactionProvider from '../components/DuplicateSalesTransactionProvider';
import CreateOfferSessionForm from './CreateOfferSessionForm';
import CreateSalesTransactionForm from './CreateSalesTransactionForm';
import { Page, useCreateSalesTransactionState } from './CreateSalesTransactionStateProvider';
import CreateVehiclePrefillForm from './CreateVehiclePrefillForm';

const CreateSalesTransactionInner = () => {
    const {
        state: { currentPage },
    } = useCreateSalesTransactionState();

    switch (currentPage) {
        case Page.VehiclePrefill:
            return <CreateVehiclePrefillForm />;

        case Page.VehicleForm:
            return (
                <DuplicateSalesTransactionProvider>
                    {checkDuplicateCarPlate => (
                        <CreateSalesTransactionForm checkDuplicateCarPlate={checkDuplicateCarPlate} />
                    )}
                </DuplicateSalesTransactionProvider>
            );

        default:
            return <CreateOfferSessionForm />;
    }
};

export default CreateSalesTransactionInner;
